enum sizes {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  Sub = 'sub',
  L = 'l',
  M = 'm',
  S = 's',
  Button = 'button',
  MobH1 = 'h1Mob',
  MobH2 = 'h2Mob',
  MobH3 = 'h3Mob',
  MobH4 = 'h4Mob',
  MobH5 = 'h5Mob',
  MobSub = 'subMob',
  MobL = 'lMob',
  MobM = 'mMob',
  MobS = 'SMob',
}

enum fonts {
  tenor = 'tenor',
  nunito = 'nunito',
}

export namespace EText {

  export type TSize = keyof typeof sizes;
  export type TFont = keyof typeof fonts;

  export function getSize(sizeName: TSize): string | undefined {
    if (sizes.hasOwnProperty(sizeName)) {
      return sizes[sizeName];

    } else {
      console.warn(`Text not found for name: ${sizeName}`);
      return undefined;
    }
  }
}
